module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "BMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "BMTNI"
  }, [_vm._v("This book could never have been written without the following authors: William Faulkner (especially for his novel "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Absalom, Absalom!)")]), _vm._v(", Zora Neale Hurston, James Weldon Johnson, W. E. B. DuBois, Charles W. Chestnutt, Laura C. Jarmon, Marc Fisher, Lorraine Johnson-Coleman, Dennis Danvers (for giving me "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Richmond Reader")]), _vm._v(" on indefinite loan), Carol A. Kolmerten, Stephen M. Ross, Judith Bryant Wittenberg, Adam Braver, Edward P. Jones, Langston Hughes, Gloria Naylor, and last but not least, Toni Morrison and Alice McDermott.")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("People I can’t thank enough for their help and support and numerous rereadings of the manuscript: Lisa Grubka, my fabulous agent, and Barbara Jones, my amazing editor and teacher.")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("Any acknowledgment would be incomplete without thanking Vicki Sipe for her love and patience when I needed a quiet house, and her willingness to read, read, read, and read again.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 69
// module chunks = 0